export enum TaskOutcomeTypes {
    Completed = 1,
    NoAnswerSnoozeForOneHour = 2,
    NoAnswer = 3,
    WrongNumber = 4
}